export const quotesTickersRoutes = {
  tickerDetails: { proxy: 'quotes/ticker-detail', upstream: 'v3/tickerDetail' },
} as const;
